const genGochiStatuses = [
  {
    id: 0,
    name: '未確認'
  },
  {
    id: 1,
    name: '成功'
  },
  {
    id: 2,
    name: '失敗'
  },
  {
    id: 3,
    name: '確認済'
  },
  {
    id: 4,
    name: '処理中'
  }
];

export default genGochiStatuses;
